import { useMutation } from '@tanstack/react-query'

import { AtualizarPessoaJuridica } from '@/features/proposta/services/atualizar-pessoa-juridica.service'
import type { TUpdatePessoaJuridicaData } from '@/shared/interfaces/conta.types'

export const useMutationAtualizarPessoaJuridica = () => {
  return useMutation({
    mutationFn: async (pessoaJuridica: TUpdatePessoaJuridicaData) => {
      const response = await new AtualizarPessoaJuridica().execute(pessoaJuridica)
      return response
    },
  })
}
